/**
 * ติดต่อ dev server (apps/liff/server) — ของจริงจะเป็น PostgREST/supabase-js ด้วย JWT พนักงาน สลับที่ไฟล์นี้ไฟล์เดียว
 * ผลลัพธ์คือ `IntakeResult` ของ packages/slip-intake ตรง ๆ — ไม่มีตรรกะบันทึกฝั่งนี้
 */
import type { IntakeResult } from "@pidyod/slip-intake";

/** URL เต็มของ Worker pidyod-api — ฝัง build-time ผ่าน esbuild define (scripts/build.ts) จาก .env WORKER_API_URL */
declare const __WORKER_API_URL__: string;

export interface Me {
  mode: "dev" | "line";
  liffId: string | null;
  staff_id: string;
  staff_name: string;
  shops: Array<{ shop_id: string; shop_name: string }>;
}

let lineUserId: string | null = null;

/** โหมด line: โหลด LIFF SDK · init · login · ใช้ userId เป็นตัวระบุพนักงาน (dev server แมปกับ profiles.line_user_id) */
async function ensureLine(liffId: string): Promise<void> {
  if (lineUserId) return;
  await new Promise<void>((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://static.line-scdn.net/liff/edge/2/sdk.js";
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("โหลด LIFF SDK ไม่ได้"));
    document.head.appendChild(s);
  });
  const liff = (window as unknown as { liff: { init(o: { liffId: string }): Promise<void>; isLoggedIn(): boolean; login(): void; getProfile(): Promise<{ userId: string }> } }).liff;
  await liff.init({ liffId });
  if (!liff.isLoggedIn()) { liff.login(); await new Promise(() => {}); } // redirect ออกไป
  lineUserId = (await liff.getProfile()).userId;
}

function headers(extra: Record<string, string> = {}): Record<string, string> {
  return lineUserId ? { ...extra, "x-line-user-id": lineUserId } : extra;
}

/** parse JSON แบบไม่โยน "Unexpected token" ดิบ — Worker ยัง Hello World placeholder อยู่ อาจตอบข้อความล้วน ไม่ใช่ JSON */
async function readJson(res: Response): Promise<unknown> {
  try { return await res.json(); } catch { return {}; }
}

export async function fetchMe(): Promise<Me> {
  let res = await fetch(`${__WORKER_API_URL__}/api/me`, { headers: headers() });
  if (res.status === 401) {
    const { liffId } = (await readJson(res)) as { liffId: string };
    await ensureLine(liffId);
    res = await fetch(`${__WORKER_API_URL__}/api/me`, { headers: headers() });
  }
  if (!res.ok) throw new Error((await readJson(res) as { error?: string }).error ?? `HTTP ${res.status}`);
  return (await readJson(res)) as Me;
}

export async function submitSlip(p: { blob: Blob; shopId: string; clientUuid: string; kind: string }): Promise<IntakeResult> {
  const res = await fetch(`${__WORKER_API_URL__}/api/slips`, {
    method: "POST",
    headers: headers({ "content-type": "image/jpeg", "x-shop-id": p.shopId, "x-client-uuid": p.clientUuid, "x-kind": p.kind }),
    body: p.blob,
  });
  if (!res.ok && res.status !== 200) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as IntakeResult;
}
